import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useMaterialRequisitionFilterParams = ({ requisitionType }) => {
	const filterData = useSelector((store) => store.filterFieldStore);
	// const [filterRequestBody, setFilterRequestBody] = useState({});

	const filterRequestBody = useMemo(() => {
		let requestedSplitDate = null;
		let requiredSplitDate = null;
		if (filterData?.requestDate?.[0]?.key) {
			let selectedDate = filterData?.requestDate?.[0]?.key;
			requestedSplitDate = selectedDate.split(',');
		}
		if (filterData?.requiredDate?.[0]?.key) {
			let selectedDate = filterData?.requiredDate?.[0]?.key;
			requiredSplitDate = selectedDate.split(',');
		}
		let tmpObject = {
			brandIdList:
				filterData?.brandIds?.map((item) => item.key)?.filter((item) => item !== 'ALL') || [],
			requestorIdList:
				filterData?.createdByIds?.map((item) => item.key)?.filter((item) => item !== 'ALL') || [],
			fabricConstructionGroupIdList:
				filterData?.supplierCategoryList?.map((item) => item.key)?.filter((item) => item !== 'ALL') ||
				[],
			statusList:
				filterData?.filterSubCategoryList
					?.map((item) => item.key)
					?.filter((item) => item !== 'ALL') || [],
			purposeList:
				filterData?.purposeList?.map((item) => item.key)?.filter((item) => item !== 'ALL') || [],
			referenceId: filterData?.name?.[0]?.key || null,
			fromRequestDate: requestedSplitDate?.[0] || null,
			toRequestDate: requestedSplitDate?.[1] || null,
			fromRequiredWithinDate: requiredSplitDate?.[0] || null,
			toRequiredWithinDate: requiredSplitDate?.[1] || null,
			requisitionType: requisitionType
		};
		return Object.fromEntries(
			Object.entries(tmpObject).filter(
				([, value]) => !(Array.isArray(value) && value.length === 0) && value !== null
			)
		);

		// setFilterRequestBody(tmpObject);
	}, [filterData, requisitionType]);

	return { filterRequestBody };
};
export default useMaterialRequisitionFilterParams;
